import { Box, Checkbox, TextField, Typography, useTheme } from "@mui/material";
import { ProductOption } from "lib/features/checkout/checkoutService";
import { useState } from "react";
import { additionalInformationStyles as styles } from "styles/Checkout/additionalInformation.styles";
import DropDownIcon from "../../../assets/icons/black_down_arrow.svg";


interface AdditionalInformationProps {
  price: number;
  unit_name: string;
  setPrice: (value: number) => void;
  ticket: any | undefined;
  basePrice: any | undefined;
  additionalOptions: ProductOption[];
  setAdditionalOptions (value: ProductOption[]) : void;
}

const AdditionalInformation = ({
  price,
  setPrice,
  additionalOptions,
  setAdditionalOptions,
}: AdditionalInformationProps) => {
  const theme = useTheme();

  const [selectedQuantity, setSelectedQuantity] = useState<{ [key: number]: number }>({});
  const [previousSelectedQuantity, setPreviousSelectedQuantity] = useState<{ [key: number]: number }>({});
  const [isOpen, setIsOpen] = useState<{ [key: number]: boolean }>({});
  const [checkedItems, setCheckedItems] = useState<{ [key: number]: boolean }>({});


  const handleToggleDropdown = (index: number) => {
    setIsOpen((prev) => ({ ...prev, [index]: !prev[index] }));
  };


  const handleQuantityChange = (index: number, quantity: number, option: ProductOption) => {
     console.log("Before change", additionalOptions);
     const previousQuantity = previousSelectedQuantity[index] || 0; // Get previously selected quantity
     console.log("Before change", additionalOptions);
    // // Calculate the new total price
     const newTotalPrice = price - previousQuantity * option.price + quantity * option.price;
    setAdditionalOptions(additionalOptions); // Update the state with the modified additional options
    setPreviousSelectedQuantity((prev) => ({ ...prev, [index]: quantity })); // Track last selection
    setSelectedQuantity((prev) => ({ ...prev, [index]: quantity }));
     setPrice(newTotalPrice);

    // // Close dropdown
     setIsOpen((prev) => ({ ...prev, [index]: false }));
  };


  const handleCheckboxChange = (index: number, addOnPrice: number) => {
    const isChecked = !checkedItems[index]; // Toggle state
    
    setAdditionalOptions(additionalOptions);
    setCheckedItems((prev) => ({ ...prev, [index]: isChecked }));
    setPrice(isChecked ? price + addOnPrice : price - addOnPrice);
  };


  
  const textInputs = additionalOptions?.filter((ao: any) => ao.type === 1 && ao?.price > 0);
  const quantitySelections = additionalOptions?.filter((ao: any) => ao.type === 2 && ao?.price > 0);
  const checkboxes = additionalOptions?.filter((ao: any) => ao.type === 3 && ao?.price > 0);
  // console.log("additionalOptions", additionalOptions);
  // console.log("textInputs", textInputs);
  // console.log("quantitySelections", quantitySelections);
  // console.log("checkboxes", checkboxes);

  return (
    <Box>
      {additionalOptions && additionalOptions?.length > 0 && (
        <Typography
          sx={styles.sectionHeader(theme)}
        >
          Additional Options
        </Typography>
      )}


      {/* Render Text Inputs (Type 1) */}
      {textInputs.map((item: any, index: number) => (
        <Box key={index}>
          <Typography sx={styles.label(theme)}>
            {item?.header}
          </Typography>

          <TextField
            key={index}
            fullWidth
            placeholder={item?.placeholder}
            sx={styles.textField}
          />
        </Box>
      ))}


      {/* Render Quantity Selection Dropdowns (Type 2) */}
      {quantitySelections.map((item: ProductOption, index: number) => (
        <Box key={index}>
          <Typography sx={styles.label(theme)}>
            {item?.header}
          </Typography>

          <Box sx={styles.dropdownContainer}>
            <Box
              sx={styles.dropdownToggle}
              onClick={() => handleToggleDropdown(index)}
            >
              <Typography sx={styles.selectedQuantityText}>
                {item.selectedValue || 0}
              </Typography>
              <Typography sx={styles.priceText}>
                ${item?.price}
              </Typography>
              <img src={DropDownIcon} />
            </Box>

            {/* DropDown */}
            {isOpen[index] && (
              <Box sx={styles.dropdownMenu(theme)}>
                {Array.from(
                  { length: item?.availability + 1 },
                  (_, index) => index
                ).map((qty, i) => (
                  <Box
                    key={i}
                    sx={styles.dropdownItem(theme)}
                    onClick={() => {
                      item.selectedValue = qty; // Update the selected value in the item
                      handleQuantityChange(index, qty, item)}}
                  >
                    {qty}
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Box>
      ))}


      {/* Render Checkboxes (Type 3) */}
      {checkboxes.length > 0 && (
        <Typography sx={styles.label(theme)}>
          Other Add-ons:
        </Typography>
      )}

      {checkboxes.map((option: ProductOption, index: number) => (
        <Box
          key={index}
          sx={styles.checkboxContainer}
        >
          <Checkbox
            checked={checkedItems[index] || false}
            onChange={() =>{
              if(option.selectedValue === undefined || option.selectedValue === 0) {
              option.selectedValue = 1; // Set to 1 if not already set
              } else {    
               option.selectedValue = 0;}
                // Update the selected value in the item
              handleCheckboxChange(index, option?.price)}
              }
            sx={styles.checkbox}
          />
          <Box sx={styles.checkboxContent}>
            <Typography
              sx={styles.checkboxHeader(theme)}
            >
              {option?.header}
              <Typography sx={styles.checkboxPrice}>${option?.price}</Typography>
            </Typography>
            <Typography
              variant="body2"
              sx={styles.checkboxDescription}
            >
              {option?.description ?? ""}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default AdditionalInformation;
